const A = process.env.NODE_ENV === "development", P = () => A, r = () => !!window.__STORYBOOK__, T = () => window.__DEPLOYMENT__ === "stag" || window.__ENVIRONMENT__ === "staging", t = () => window.__DEPLOYMENT__ === "prod", i = () => window.__ENVIRONMENT__ === "production", c = () => window.__ENVIRONMENT__ === "prod-eu", R = () => window.__ENVIRONMENT__ === "prod-sandbox", S = () => !!window.__NAMESPACE__ || !!window.location.origin.match(
  "-stargate-client.prod-sandbox.amplitude.com"
) || !!window.location.origin.match("-audiences.prod-sandbox.amplitude.com"), d = () => ({
  ...window.__AMP_FEATURE_FLAGS__
}), e = (_) => {
  var n, o;
  return (o = (n = window.__AMP_FEATURE_FLAGS__) == null ? void 0 : n[_]) == null ? void 0 : o.value;
}, N = (_) => e(_) === "on", O = () => s("REACT_APP_ENV"), E = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ANALYTICS_HOST: process.env.REACT_APP_ANALYTICS_HOST,
  REACT_APP_DASH_HOST: process.env.REACT_APP_DASH_HOST,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
  REACT_APP_ORBIT_HOST: process.env.REACT_APP_ORBIT_HOST,
  REACT_APP_PUBLIC_BASE_PATH: process.env.REACT_APP_PUBLIC_BASE_PATH,
  REACT_APP_SKYLAB_BACKEND_HOST: process.env.REACT_APP_SKYLAB_BACKEND_HOST,
  REACT_APP_THUNDER_HOST: process.env.REACT_APP_THUNDER_HOST,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_SESSION_REPLAY_HOST: process.env.REACT_APP_SESSION_REPLAY_HOST
}, s = (_) => {
  var n;
  return ((n = window.env) == null ? void 0 : n[_]) || E[_] || "";
}, w = (_, n) => {
  window.env && (window.env[_] = n), E[_] = n;
};
export {
  A as IS_DEV,
  d as getAllFlagValues,
  O as getCurrentEnvironment,
  s as getEnv,
  e as getFlagValue,
  P as isDev,
  S as isEphemeralEnv,
  N as isFlagEnabled,
  t as isProd,
  c as isProdEu,
  R as isProdSandbox,
  i as isProdUs,
  T as isStaging,
  r as isStorybook,
  E as processEnv,
  w as setEnv
};
//# sourceMappingURL=env.js.map
